module.exports = __webpack_public_path__ + "static/img/lpbody-2.dd324e86.jpg";